(function ($) {

    $(document).on( 'click', '[data-copy-to-clipboard]', function () {
        let $this = $(this);
        const copyText = $this.data('copy-to-clipboard');

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText);

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(copyText).then(function () {
                showCopyNotification($this);
            });
        } else {
            var $tempInput = $('<input>');
            $('body').append($tempInput);
            $tempInput.val(copyText).select();
            try {
                if (document.execCommand('copy')) {
                    showCopyNotification($this);
                }
            } catch (err) {

            }
            $tempInput.remove();
        }
    });

    function showCopyNotification($element) {
        var $notice = $('<div class="pos__copy-notice">' + scripts_translations.copied + '</div>');
        $element.append($notice);

        $notice.fadeIn(300).delay(1000).fadeOut(300, function () {
            $(this).remove();
        });
    }


})(jQuery)